// extracted by mini-css-extract-plugin
module.exports = {"roofSVG":"roof-SVG-module--roof-SVG--iR0a2"};